import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AuthStoreService, ContentGqlService, ContentStoreService, UserSettings } from '@motivforce/mx-library-angular';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { IsLoadingService } from '@service-work/is-loading';
import { filter, map, skip, take } from 'rxjs';
import { BoostTrainingStatus } from 'src/app/core/model/lenovo/boost-training-status';
import { User } from 'src/app/core/model/user';
import { UserStoreService } from 'src/app/core/store/user-store.service';

@UntilDestroy()
@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
})
export class ProfileMenuComponent implements OnInit {
  user$ = this.authStore.userSettings$.pipe(map((settings) => (settings ? settings.user : null)));

  profileMenu: any;
  isEmea: boolean;
  trainingStatus: BoostTrainingStatus | undefined;

  constructor(
    private offcanvasService: NgbOffcanvas,
    private authStore: AuthStoreService,
    private router: Router,
    private isLoadingService: IsLoadingService,
    private contentStore: ContentStoreService,
    private contentGql: ContentGqlService,
    private translateService: TranslateService,
    private userStore: UserStoreService
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        untilDestroyed(this),
        filter((event) => event instanceof NavigationStart)
      )
      .subscribe(() => this.offcanvasService.dismiss());

    this.authStore.userSettings$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((userSettings) => {
      if (userSettings.user != null) {
        const { user } = this.authStore.userSettings as UserSettings<User>;
        this.isEmea = user?.region?.regionCode === 'EMEA';
        if (this.isEmea) {
          this.userStore.getTrainingStatus();
        }
      }
    });

    this.userStore.trainingStatus$.pipe(filter(Boolean), untilDestroyed(this)).subscribe((trainingStatus) => {
      this.trainingStatus = trainingStatus;
    });
  }

  open(content: any) {
    this.offcanvasService.dismiss();
    this.offcanvasService.open(content, {
      ariaLabelledBy: 'offcanvas-basic-title',
      position: 'end',
      panelClass: 'profile-menu-panel',
      scroll: true,
    });
  }

  logOut() {
    this.authStore.authenticatedUser$.pipe(untilDestroyed(this), skip(1), take(1)).subscribe(() => {
      window.location.reload();
    });

    this.authStore.signOut();
  }
}
